// apps/client/src/components/errors/Error404.tsx
import React from 'react';
import ErrorTemplate, { ErrorButtons } from './ErrorTemplate';

export const Error404: React.FC = () => {
  return (
    <ErrorTemplate
      title="404"
      heading="Page Not Found"
      message="The page you're looking for doesn't exist. It may have been moved, deleted, or you entered the wrong URL."
      buttons={[ErrorButtons.HOME, ErrorButtons.BACK]}
    />
  );
};

export default Error404;
